
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { BulkEditDialog } from "./BulkEditDialog";
import { App } from "@/types/app";

interface AppCatalogHeaderProps {
  selectedCount: number;
  selectedApps: App[];
  onBulkDelete: () => void;
  onBulkImport?: () => void;
  onBulkEditSuccess: () => void;
  isDeleting: boolean;
}

export const AppCatalogHeader = ({ 
  selectedCount,
  selectedApps,
  onBulkDelete, 
  onBulkEditSuccess,
  isDeleting 
}: AppCatalogHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-4">
      <div className="flex items-center gap-2">
        {selectedCount > 0 && (
          <>
            <BulkEditDialog 
              selectedApps={selectedApps}
              onClose={() => {}}
              onSuccess={onBulkEditSuccess}
            />
            <Button
              variant="destructive"
              size="sm"
              onClick={onBulkDelete}
              disabled={isDeleting}
              className="flex items-center gap-2"
            >
              <Trash2 className="w-4 h-4" />
              Delete {selectedCount} app{selectedCount === 1 ? '' : 's'}
            </Button>
          </>
        )}
      </div>
      
      {selectedCount > 0 && (
        <p className="text-sm text-gray-600">
          {selectedCount} app{selectedCount === 1 ? '' : 's'} selected
        </p>
      )}
    </div>
  );
};
